module.exports = __webpack_public_path__ + "images/category_lp/common/woman_50_efbb32e616491be3c36f85dcce99cef3.png";